import { useMemo } from 'react';
import type { DemoOption } from '@shared/schemas/admin-access';
import { searchRank } from './searchRank';

/** The one demo-identity filter: server order is kept, an empty query keeps everything. */
export function filterDemoOptions(options: readonly DemoOption[], query: string): DemoOption[] {
  return options.filter((option) => query.trim().length === 0 || searchRank(option.label, query) >= 0);
}

export function useDemoOptions(options: readonly DemoOption[] | undefined, query: string): DemoOption[] {
  return useMemo(() => filterDemoOptions(options ?? [], query), [options, query]);
}
